import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import l from '../lang';

/**
 * Printing error message from server response. Server response will send status 400 with validation object.
 * @param validation array
 * @param fieldName string
 */
const ErrorMessage = ({ validation, fieldName, user }) => {
    const errorMessages = validation.filter(o => o.param === fieldName);
    if (errorMessages.length === 0) return null;
    l.setLanguage(user.language);
    return (
        <div className="error-message">
            {errorMessages.map(o => (<p key={o.param}>{l.serverMessage[o.msg] || o.msg}</p>))}
        </div>
    );
};

ErrorMessage.propTypes = {
    validation: propTypes.array.isRequired,
    fieldName: propTypes.string.isRequired,
    user: propTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorMessage);
